import { Logo } from '../logo';
import { LoadingDots } from '../ui/loading-dots';

export function LoadingInitial() {
  return (
    <div className="h-screen w-full flex-full-center flex-col">
      <div className="flex-1 flex-full-center flex-col mb-16">
        <Logo variant="vertical" className="w-48 object-scale-down mt-4" />
      </div>
      <div className="mb-8">
        <LoadingDots />
      </div>
    </div>
  );
}
